import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common'], { keyPrefix: 'assessments' });
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const title = t('create_title');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.Assessment,
    parent: null,
    hrefRoot: '',
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Title-only object toolbar (CUS-163) — the create form keeps its own
      // Create/Cancel buttons, so no save/actions here. Flag-gated.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Assessment}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
